import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../core/service/common-service/common.service';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { FormControl, FormGroup, FormBuilder, Validators, FormGroupDirective } from '@angular/forms';
import { MatDialog, MatSort, MatPaginator, MatTableDataSource } from "@angular/material";
import { element } from 'protractor';

@Component({
  selector: 'app-cdm-customer360',
  templateUrl: './cdm-customer360.component.html',
  styleUrls: ['./cdm-customer360.component.scss']
})
export class CdmCustomer360Component implements OnInit {

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild('RemarksPaginator', { static: true }) remarksPaginator: MatPaginator;
  @ViewChild('RemarksSort', { static: true }) remarksSort: MatSort;

  custDataForm : FormGroup;
  formData = new FormData();

  spinner: boolean;
  selectedVehicle: any;
  flag: boolean;
  ticketId: string;
  custId: string;
  customerData: any;
  customerDetail: any;
  customerName: string;
  customerNumber: string;
  remark: string;
  fileTypeSelect: string;
  userRoles: string;
  autoFillData: any;
  fileValue: any;
  userId: string;
  userInfo: any;
  filePath: string;
  serviceDetail: any;
  remarksDetails: any;
  vin: string;
  remarksCount: number = 0;
  buttonFlag: boolean;
  submitted: boolean;
  customerId: string;

  fileType: any[] = [
    { value: 'PDF', type: 'PDF'},
    { value: 'PDF', type: 'PDF'},
    { value: 'PDF', type: 'PDF'},
  ];

  //call log table columns
  displayedRemarksColumns: string[] = [
    "remarkBy",
    "remarkDate",
    "remark"
  ];
  attachmentName: string;
  chassisNo: any[] = [];
  uiFileName: any;
  showDownloadButton: boolean;

  constructor(private commonService: CommonService, private router: Router, private toastr: ToastrService,
    private datePipe: DatePipe, private formBuilder: FormBuilder) {  }

  ngOnInit() {
    this.customerData = JSON.parse(localStorage.getItem("customerData")) || {};
    this.custId = this.customerData.customerId;
    this.ticketId = this.customerData.ticketId;
    this.vin = this.customerData.vin;
    this.userRoles = localStorage.getItem('userRoles');
    this.userId = localStorage.getItem('userId');
    let userInfo = JSON.parse(localStorage.getItem('userInfo'));
    this.userInfo = userInfo[0];
    this.getCustomerDetail();
    this.fetchLogs();
    //if(this.userRoles != "CRE") {
      this.fetchCdmDBData();
    //}
    this.buildLoginForm();
    this.checkAccess();
  }

  /**
  * Name: buildLoginForm
  * purpose: To create customer data form
  */
  buildLoginForm() {
    this.custDataForm = this.formBuilder.group({
      customerName: ['', Validators.required],
      customerNumber: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
      fleetName: [''],
      fleetNumber: ['', [Validators.minLength(10), Validators.maxLength(10)]],
      remark: ['',Validators.required],
      fileTypeSelect: ['']
    });
  }

  /**
  * Name: fetchLogs
  * purpose: To get Customer Detail
  */
  fetchLogs(): void {
    this.spinner = true;
    this.commonService.fetchLogs(this.custId, this.ticketId, this.userId, this.userInfo.roleId)
      .subscribe(res => {
        if (res["responseCode"] == 0) {
          let remarks = res['responseData'];
          remarks.forEach(element => {
            let date = element.remarkTime + " GMT+0000";
            let d = new Date(date);
            element.remarkTime = d;
            element.remarkDate = this.datePipe.transform(element.remarkTime, "yyyy-MM-dd");
          });
          this.remarksDetails = new MatTableDataSource(remarks);
          this.sort.direction = '';
          this.remarksDetails.sort = this.remarksSort;
          this.remarksDetails.paginator = this.remarksPaginator;
          this.remarksCount = remarks.length;
        } else {
          this.spinner = false;
        }
      }, err => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      });
  }

  /**
  * Name: getCustomerDetail
  * purpose: To get Customer Detail
  */
  getCustomerDetail(): void {
    this.spinner = true;
    let vin = []
    this.commonService.getCustomerDetail(this.custId, this.ticketId, this.userId, this.userInfo.roleId)
      .subscribe(res => {
        if (res['responseCode'] == 0 && res['responseData'] != undefined) {
          this.spinner = false;
          this.customerDetail = res['responseData'];
          this.customerId = this.customerDetail.customerCode;
          vin = this.customerDetail.vin.split(',');
          vin.forEach(element => {
            this.chassisNo.push(element);
          })
        } else {
          this.spinner = false;
          this.toastr.error(res['message'], "Error");
        }
      }, err => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      });
  }

  submit(): void {
    this.submitted = true;
    if(this.custDataForm.valid) {
      this.spinner = true;
      //this.filePath = "";
      let request = '{' + '"custId" : "'+this.custId + '","ticketNo" : "'+this.ticketId + '","custName" : "' + this.custDataForm.value.customerName
        + '","contactNo" : "' + this.custDataForm.value.customerNumber + '","fleetName" : "' + this.custDataForm.value.fleetName + '","fleetContact" : "'
        + this.custDataForm.value.fleetNumber + '","remarks" : "' + this.custDataForm.value.remark
        + '","userId" : "' + this.userId + '","userRole" : "' + this.userInfo.roleId + '"}';
      let data = {
        file: this.formData,
        model: request,
      };

      this.commonService.saveCdmActualData(this.userId, this.userInfo.roleId, data)
      .subscribe(res => {
        if (res['responseCode'] == 0 && res['responseData'] != undefined) {
          this.toastr.success(res['message'], "Success");
          this.spinner = false;
          this.submitted = false;
          this.router.navigate(["cdm-calling"]);
        } else {
          this.spinner = false;
          this.submitted = false;
          this.toastr.error(res['message'], "Error");
        }
      }, err => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      });
    }
  }

  clear(): void {
    this.custDataForm.reset();
  }

  Accept(value: any) {
    this.submitted = true;
    if(this.custDataForm.valid) {
      this.spinner = true;
      let request = '{' + '"custId" : "'+this.custId + '","ticketNo" : "'+this.ticketId + '","custName" : "' + this.custDataForm.value.customerName
        + '","contactNo" : "' + this.custDataForm.value.customerNumber + '","fleetName" : "' + this.custDataForm.value.fleetName + '","fleetContact" : "'
        + this.custDataForm.value.fleetNumber + '","remarks" : "' + this.custDataForm.value.remark
        + '","userId" : "'  + this.userId + '","status" : "' + value + '","userRole" : "' + this.userInfo.roleId + '"}';

      let data = {
        file: this.formData,
        model: request,
      };
      this.commonService.updateCdmStatus(this.userId, this.userInfo.roleId, data)
        .subscribe(res => {
          if (res['responseCode'] == 0 && res['responseData'] != undefined) {
            this.toastr.success(res['message'], "Success");
            this.spinner = false;
            this.router.navigate(["cdm-calling"]);
          } else {
            this.spinner = false;
            this.toastr.error(res['message'], "Error");
          }
        }, err => {
          this.spinner = false;
          this.toastr.error("Something went wrong, Please try again.", "Error");
        });
    }
  }

  /**
  * Name: fetchCdmDBData
  * purpose: To get Customer Detail
  */
  fetchCdmDBData(): void {
    let remarkCheck=true
    this.spinner = true;
    this.commonService.fetchCdmDBData(this.custId, this.ticketId, this.userId, this.userInfo.roleId)
      .subscribe(res => {
        if (res['responseCode'] == 0 && res['responseData'] != undefined) {
          this.spinner = false;
          this.autoFillData = res['responseData'];
          if(this.userRoles=='Vecv SRM User' || this.userRoles=='CRE' ){
            remarkCheck=false
          }
          this.custDataForm = this.formBuilder.group({
            customerName: this.autoFillData.customerName || '',
            customerNumber: [this.autoFillData.customerContactNo || '', [Validators.minLength(10), Validators.maxLength(10)]],
            fleetName: this.autoFillData.fleetName || '',
            fleetNumber: [this.autoFillData.fleetContactNo || '', [Validators.minLength(10), Validators.maxLength(10)]],
            remark: remarkCheck==true?(this.autoFillData.remarks || ''):'',
            //fileTypeSelect: ''
          })
          this.fileValue = this.autoFillData.attachment;
          if(this.fileValue==""||this.fileValue==null){
            this.showDownloadButton=false
          }else if(this.fileValue!=""||this.fileValue!=null){

            this.createUiFilename()
            this.showDownloadButton=true
          }


          //this.custDataForm.setValue['customerName']
        } else {
          this.spinner = false;
          this.toastr.error(res['message'], "Error");
        }
      }, err => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      });
  }

  createUiFilename(){
    let file=this.fileValue
    let fileArray=file.split('/')
    let lastElement=fileArray[fileArray.length-1]
    let lastName=lastElement.split("-")
    this.uiFileName=lastName[lastName.length-1]
  }

  downloadFile(): void {
    this.spinner = true;
    if(this.fileValue) {
      let fileType = this.fileValue.split('.')[1];
      let fileName = this.customerId.concat('.').concat(fileType);
      this.commonService.downloadFile(this.fileValue)
        .subscribe(fileData => {
          if (fileData) {
            const blob: any = new Blob([fileData], { type: 'application/octet-stream' });
            let link = document.createElement("a");
            if (link.download !== undefined) {
              let url = URL.createObjectURL(blob);
              link.setAttribute("href", url);
              link.setAttribute("download", fileName);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              this.spinner = false;
            }
          } else {
            this.spinner = false;
          }
        }, err => {
          this.spinner = false;

        });
    } else {
      this.toastr.success('Attachment not available.');
      this.spinner = false;
    }
  }

  onFileUpload(event: any) {
    this.attachmentName = "";
    this.formData = new FormData();
    let file: File = event.target.files[0];
    this.attachmentName = file.name;
    let filePath = event.currentTarget.value.split("\\")[2];
    this.formData.append('file', file, filePath);
  }

  checkAccess() {
    if(this.userRoles == "CRE") {
      if(this.customerData.requestStatus == "Submitted" || this.customerData.requestStatus == "Accepted") {
        this.flag = true;
        this.buttonFlag = true;
      } else {
        this.flag = false;
        this.buttonFlag = false;
      }
    } else if(this.userRoles == "Vecv SRM User") {
      if(this.customerData.requestStatus == "Submitted" || this.customerData.requestStatus == "Open") {
        this.flag = false;
        this.buttonFlag = false;
      } else {
        this.flag = true;
        this.buttonFlag = true;
      }
    } else {
      this.flag = true;
      this.buttonFlag = true;
    }
  }

  /**
  * Name: hasCustDataError
  * purpose: To check if customer form has any error
  * @param {any} control - form control
  * @return {boolean} flag to determine if form is valid.
  */
  hasError(control: any): boolean {
    return (
      control &&
      (this.submitted || control.touched || control.dirty) &&
      !control.valid
    );
  }
}
